import { isTypeTestimonial, TypeTestimonialSkeleton } from '@platform/contentful';
import { Entry } from 'contentful';

const ContentfulTestimonial = ({
  entry,
}: {
  entry: Entry<TypeTestimonialSkeleton, 'WITHOUT_UNRESOLVABLE_LINKS', 'en-US'> | undefined;
}) => {
  if (!entry || !isTypeTestimonial(entry)) {
    return null;
  }

  return (
    <div className='flex gap-2'>
      <img
        className='w-14 h-14 rounded-full'
        src={`${entry.fields.avatar?.fields.file?.url}?f=face&fit=thumb&w=56&h=56`}
        alt={entry.fields.name}
      />
      <div className='flex flex-col gap-2'>
        <p className='text-brand-600'>{entry.fields.headerLabel}</p>
        <h4 className='font-header text-base sm:text-xl leading-6 font-semibold text-gray-500'>
          {entry.fields.name}
        </h4>
        <p className='text-sm leading-5 italic'>"{entry.fields.quote}"</p>
      </div>
    </div>
  );
};

export default ContentfulTestimonial;
